import { Component } from 'preact';
import style from './style';
import { Link } from 'preact-router/match';
import Image from '@components/image';
import Popover from '@components/popover';
import Button from '@components/button';
import CitySelector from '@components/cityselector';
import AuthModal from '@components/auth';
import I18n from '@i18n';
import { Stateful } from '@components/pubsub';
import { slugify, getCity, setCity } from '@helpers';

class LanguageSelectorList extends Component {
  render(props, state, { closePopOver, lang }) {
    const languages = [
      { code: 'en', name: 'English', flag: 'gb' },
      { code: 'fi', name: 'Suomi', flag: 'fi' },
      { code: 'ee', name: 'Eesti', flag: 'ee' },
    ];

    return (
      <div class={style.languageSelectorWrapper} onClick={closePopOver}>
        <Stateful events={['hasTranslationRoute']}>
          {({ hasTranslationRoute = false }) => (
            <ul>
              {languages.map(language => (
                <li>
                  <Button
                    class={style.languageSelectorButton}
                    href={
                      hasTranslationRoute
                        ? window.location.pathname
                            .split('/')
                            .map((item, index) =>
                              index === 1 ? language.code : item
                            )
                            .join('/')
                        : `/${language.code}`
                    }
                    onClick={() =>
                      window.setTimeout(() => window.location.reload(), 16)
                    }
                  >
                    <span class={style.languageSelectorFlag}>
                      <Image
                        src={`https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/${language.flag}.svg`}
                        alt={language.name}
                        class={style.languageSelectorFlagImage}
                      />
                    </span>
                    <span class={style.languageSelectorDisplayname}>
                      {language.name}
                    </span>
                  </Button>
                </li>
              ))}
            </ul>
          )}
        </Stateful>
      </div>
    );
  }
}

class LanguageSelector extends Component {
  state = {
    showPopover: false,
  };

  togglePopover = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ showPopover: !this.state.showPopover });
  };

  closePopover = () => {
    this.setState({ showPopover: false });
  };

  render(props, { showPopover }, { lang }) {
    const languages = [
      { code: 'en', name: 'English', flag: 'gb' },
      { code: 'fi', name: 'Suomi', flag: 'fi' },
      { code: 'ee', name: 'Eesti', flag: 'ee' },
    ];

    const currentLanguage =
      languages.find(l => l.code === lang) || languages[0];

    return (
      <div class={style.languageSelectorContainer}>
        <button
          class={style.languageToggle}
          onClick={this.togglePopover}
          ref={el => (this.languageToggleRef = el)}
        >
          <span class={style.languageSelectorFlag}>
            <Image
              src={`https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/${currentLanguage.flag}.svg`}
              alt={currentLanguage.name}
              class={style.languageSelectorFlagImage}
            />
          </span>
          <span>{currentLanguage.name}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            style="margin-left: 4px"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        {showPopover && (
          <div class={style.languagePopover}>
            <LanguageSelectorList />
          </div>
        )}
      </div>
    );
  }
}

class TopBar extends Component {
  state = {
    showCitySelector: false,
  };

  toggleCitySelector = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ showCitySelector: !this.state.showCitySelector });
  };

  closeCitySelector = cityName => {
    if (cityName) {
      setCity(cityName);

      if (this.context.events) {
        this.context.events.emit('city', cityName);
      }
    }
    this.setState({ showCitySelector: false });
  };

  render(props, { showCitySelector }, { lang }) {
    return (
      <div class={style.topBar}>
        <div class={style.topBarContainer}>
          <div class={style.topBarLeft}>
            <div class={style.topBarItem}>
              <LanguageSelector />
            </div>
            <div class={style.topBarItem}>
              <Stateful events={['city']}>
                {({ city = getCity() }) => (
                  <button
                    onClick={this.toggleCitySelector}
                    class={style.topBarLink}
                    ref={el => (this.citySelectorRef = el)}
                  >
                    <span class={style.topBarIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
                      </svg>
                    </span>
                    <span>{city}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      style="margin-left: 4px"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>
                )}
              </Stateful>
              <CitySelector
                show={showCitySelector}
                onClose={this.closeCitySelector}
                anchor={this.citySelectorRef}
              />
            </div>
          </div>

          <div class={style.topBarRight}>
            <Link
              href={
                lang === 'fi'
                  ? `/fi/liity-tableonlineen`
                  : lang === 'en'
                  ? `/en/join`
                  : lang === 'ee'
                  ? `/ee/vota-meiega-uhendust`
                  : null
              }
              class={style.topBarLink}
            >
              {I18n.t('For restaurants')}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default TopBar;



// WEBPACK FOOTER //
// ./components/topbar/index.js